// src/components/comunicacion/LayoutComunicacion.jsx
import React from "react";
import SidebarComunicacion from "./SidebarComunicacion";
import DashboardComunicacion from "./DashboardComunicacion";
import AvisosUrgentes from "./AvisosUrgentes";
import NoticiasInternas from "./NoticiasInternas";
import Articulos from "./Articulos";
import CalendarioCorporativo from "./CalendarioCorporativo";
import ForosTematicos from "./ForosTematicos";
import Encuestas from "./Encuestas";
import BuzonSugerencias from "./BuzonSugerencias";
import GestorDocumentos from "./GestorDocumentos";

const LayoutComunicacion = ({ activeScreen, activeItem, onNavigate }) => {
  const renderScreen = () => {
    switch (activeScreen) {
      case "avisos":
        return <AvisosUrgentes onNavigate={onNavigate} initialItem={activeItem} />;
      case "noticias":
        return <NoticiasInternas onNavigate={onNavigate} initialItem={activeItem} />;
      case "articulos":
        return <Articulos onNavigate={onNavigate} initialItem={activeItem} />;
      case "calendario":
        return <CalendarioCorporativo onNavigate={onNavigate} />;
      case "foros":
        return <ForosTematicos onNavigate={onNavigate} initialItem={activeItem} />;
      case "encuestas":
        return <Encuestas onNavigate={onNavigate} />;
      case "buzon":
        return <BuzonSugerencias onNavigate={onNavigate} />;
      case "gestorDocumentos":
        return <GestorDocumentos onNavigate={onNavigate} />;
      case "dashboard":
      default:
        return <DashboardComunicacion onNavigate={onNavigate} />;
    }
  };

  return (
    <div className="intra-shell">
      <aside className="intra-shell-sidebar">
        <SidebarComunicacion
          activeScreen={activeScreen}
          onNavigate={onNavigate}
        />
      </aside>

      <main
        className="intra-shell-main"
        style={{
          padding: activeScreen === 'gestorDocumentos' ? 0 : undefined,
          overflow: activeScreen === 'gestorDocumentos' ? 'hidden' : undefined
        }}
      >
        {renderScreen()}
      </main>
    </div>
  );
};

export default LayoutComunicacion;
